import { render, staticRenderFns } from "./JournalFileExpandButton.vue?vue&type=template&id=03d0196a&scoped=true&"
import script from "./JournalFileExpandButton.vue?vue&type=script&lang=ts&"
export * from "./JournalFileExpandButton.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFileExpandButton.vue?vue&type=style&index=0&id=03d0196a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d0196a",
  null
  
)

export default component.exports